var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.landingFormStyle,{tag:"div",staticClass:"landing-form",attrs:{"currentListItem":_vm.currentListItem,"items":_vm.items}})
}
var staticRenderFns = []

export { render, staticRenderFns }